import { NotificationModel } from '@bymason/controller-api-hooks';
import { convertToBytes, getDataSize } from '@bymason/utils';
import { NotificationFormModel } from './types';

export function mapNotificationToFormModel(notification: NotificationModel): NotificationFormModel {
  return {
    name: notification.name,
    description: notification.description,
    threshold: getDataSize(notification.condition.value)[0] as number,
    unit: getDataSize(notification.condition.value)[1] as string,
    domain: notification.domain.type,
    recipients: notification.recipients.map((r) => r.address).join(', '),
  };
}
export function mapFormModelToNotification(notificationForm: NotificationFormModel): NotificationModel {
  return {
    name: notificationForm.name,
    description: notificationForm.description,
    recipients: notificationForm.recipients
      .trim()
      .replace(/(^,)|(,$)/g, '')
      .split(',')
      .map((r) => {
        return { type: 'email', address: r.trim() };
      }),
    condition: {
      metric: 'usageRateMonthly',
      operator: '>',
      value: convertToBytes(notificationForm.threshold as number, notificationForm.unit), // always would be a number
    },
    domain: {
      type: notificationForm.domain,
    },
  };
}
